import { FilesListing } from "../../general_components/content_management/item_page/load_page_items/filesListing";
import { LoadPayoutSection } from '../../general_components/content_management/item_page/load_page_items/loadPayoutSection';
import { StopsWithStatuses } from "../../general_components/content_management/item_page/load_page_items/stopsWithStatuses";
import { ConfirmationDialogue } from '../../general_components/forms/ConfirmationDialogue';
import { LOAD_SECTION_UPDATE, generateColumn, generateUpdatedVersionOfTheObject } from '../../supplementary_components/itemEditMethods';
import { priceOnFinish } from '../../supplementary_components/priceInputDelegate';
import { API_ROOT, sendRequest } from '../../supplementary_components/requests';
import { addPopup, addNotification } from '../../supplementary_components/store';
import { LoadTypeFormatter } from './loadAddConf';
import { Splitter } from "../../general_components/forms/input_fields/splitter";
import { RateAllocationMatrix, processRateAllocationMatrixChanges } from "../../general_components/forms/input_fields/rateAllocationMatrix";
import { processDriverPayoutChanges } from "../../general_components/forms/input_fields/driverPayoutEditor";
import { formatDriverPayoutDisplay, hasAnyExplicitDriverPayout, resolveDriverPayoutTrucks, shouldShowDriverPayout } from "../../supplementary_components/driverPayoutUtils";
import { TEMP_TRAILER_ADD_CONF } from "../trailers/trailerAddConf";
import { parseArrayOfStrings } from "../../general_components/content_management/task_list/taskListElements/diagramView";
import { createCheckBeforeSending } from "../trucks/truckPageConfComponents";
import { MarkAsReadyToInvoiceButton } from "../../general_components/content_management/item_page/load_page_items/markAsReadyToInvoice";
import { addAndRemoveLoadingIcon } from "../../general_components/content_management/item_page/driver_page_components/payoutAdjustmentsSection.js"
import { LatestActivitiesSection } from "../../general_components/content_management/item_page/latestActivitiesSection.js";
import { can, canSeeLoadRates } from "../../supplementary_components/userDataDelegate";
import { buildDispatchDataFromLoad, renderLoadDispatchInfo, retrieveLoadDispatchInfoFormat } from "../myAccount/customizations/loadDispatchInfoFormat";
function udpateLoad(updatedVersionOfTheLoad, successAction, failureAction){
    sendRequest(
        'PATCH',
        API_ROOT+'loads/edit',
        null,
        ()=>{
            successAction()
        },
        ()=>{
            failureAction()
        },
        updatedVersionOfTheLoad
    )
}
const completedLoadStatuses = ["Ready For Invoice", "Invoiced", "Paid"];

function usesCombinedRateMatrix(data) {
    return Boolean( data?.rateDistributionByWeeks
        && data.rateDistributionByWeeks.length > 1
        && data?.loadExecutors
        && data.loadExecutors.length > 1
        && data?.loadHasStarted
    );
}

function matrixEditorDefaultValue(data) {
    return {
        rateAllocationMatrix: data.rateAllocationMatrix,
        loadExecutors: data.loadExecutors,
        rateDistributionByWeeks: data.rateDistributionByWeeks,
    };
}
//`Trailer: ${this.currentTruck['currentTrailer']['trailerNumber']}`:'Bobtail'
export class LOAD_PAGE_OBJECT {
    data;
    NestedValueExtractor;
    loadStatusFormatter;
    loadStatusColorGenerator;
    EquipmentSection = () => {
        return [
            generateColumn(this.data, true, 'Current Truck', [['currentTruck','truckNumber']], {
                clickable: {id:[["currentTruck", 'id']], type: "trucks/"},
                suggestionsEnabled : true,
                suggestionsLink : API_ROOT+'trucks/trucksBySimilarTruckNumberAndAssignedTrailer?pattern=',
                dataValueRequired : true,
                autoComplete : 'off',
                displayValueGenerator : (rawValue)=>{return `${rawValue['truckNumber']} (${rawValue['currentTrailer'] ? `Trailer: ${rawValue['currentTrailer']['trailerNumber']}`:'Bobtail'})`},
                availableOptionDefiningColumnName : 'available',
                twoPartValue : {
                    mainPart : rawData => rawData['truckNumber'],
                    subPart:  rawData => `${rawData['currentTrailer'] ? "(Trailer: "+rawData['currentTrailer']['trailerNumber'] : '(Bobtail'})`
                },
                customDefaultInputValue:this.data['currentTruck']?`${this.currentTruck} (${this.data['currentTruck'] && this.data['currentTruck']['currentTrailer'] ? `Trailer: ${this.data['currentTruck']['currentTrailer']['trailerNumber']}`:'Bobtail'})`:'',
                rawValComparationFieldName : "truckNumber",
                displayValueToRawValue: (value)=>{return value.substr(0, value.indexOf('(')).trim()},
                checks : [
                    async (value, column, target) => new Promise(resolve => {
                        try {
                            const TruckNumber = value.substr(0, value.indexOf('(')).trim();
                            if(TruckNumber === this.currentTruck){
                                resolve();
                                return
                            }
                            if(this.data.loadType !== "Partial"){
                                checkIfTruckHasOverlayingLoads(TruckNumber, this.data['id'], this.data.startDate, this.data.endDate, target, column, () => {
                                    resolve();
                                });
                                return;
                            }
                        } catch (error) {
                            console.log(error);
                        }
                        resolve();
                    }),
                ]
                // afterSelection : (val)=>{
                //     const parsedVal = JSON.parse(val);
                    
                //     const form = document.getElementById('Edit Load');
                //     const currentTrailerInput = form.querySelector('input[name="currentTrailer"]');
                //     try {
                //         if((currentTrailerInput.getAttribute('data-value') === "null" || currentTrailerInput.getAttribute('data-value') === '')
                //         && parsedVal.currentTrailer){
                //             const stopsArray = this.data["stops"];
                //             sendRequest('GET', API_ROOT+`trailers/trailersByNumberAndAvailablityForDates?dates=${stopsArray[0].apptDate}-${stopsArray[stopsArray.length-1].apptDate}&loadType=${this.loadType}&currentTrailer=&pattern=`+parsedVal.currentTrailer.trailerNumber, null, (value)=>{
                //                 for (const entry of value){
                //                     if (parsedVal.currentTrailer.trailerNumber === entry.trailerNumber){
                                        
                //                         if(entry.available === true){
                //                             //Assinging Dummy node in order to change it to Truck's current trailer 
                //                             //(This is done to be able to check if the trailer is coming from the truck)
                //                             currentTrailerInput.setAttribute('data-value', JSON.stringify({id: 1, trailerNumber: 'GetTrucksTrailer'}));
                //                             currentTrailerInput.value = parsedVal.currentTrailer.trailerNumber;
                //                         }
                //                         return true;
                //                     }
                //                 } 
                //             }, null, null);  
                            
                //         }
                //     } catch (error) {
                //         console.log(error);
                //     }
                //     return true;
                // },
                
            }),
            generateColumn(this.data, true, 'Current Trailer', [['currentTrailer','trailerNumber']], {
                clickable: {id:[['currentTrailer', 'id']], type: "trailers/"},
                mandatory: this.data['loadHasStarted'],
                suggestionsEnabled : true,
                suggestionsLink : API_ROOT+`trailers/trailersByNumberAndAvailablityForDates?dates=${this.data["stops"][0].apptDate}-${this.data["stops"][this.data["stops"].length-1].apptDate}&currentTrailer=${this.currentTrailer === '-'?'':this.currentTrailer}&loadType=${this.loadType}&pattern=`,
                addNewButton: {label:'Add Temporary Trailer', configuration:TEMP_TRAILER_ADD_CONF},
                prefillConditioning:(val)=>{
                    return {val: val, index:3};
                },
                dataValueRequired : true,
                autoComplete : 'off',
                displayValueGenerator : (rawValue)=>{return rawValue['trailerNumber']},
                // displayValueToRawValue: (value)=>{return value.substr(0, value.indexOf('(')).trim()},
                availableOptionDefiningColumnName : 'available',
                twoPartValue : {
                    mainPart : rawData => rawData['available'] ? rawData['trailerNumber'] : '',
                    subPart:  rawData => `${rawData['trailerNumber'] === this.currentTrailer ? "Currently Assigned" : !rawData['available'] ? `${rawData['trailerNumber']} (Conflicting Load: #${rawData['loadNumber']})`: rawData['loadNumber'] !== "" ? `(Assigned to Load ${rawData['loadNumber']})` : "" }`
                },
                afterMinimumChars:2
            }),
        ]
    }
    InfoSectionColumns = (skipFirst)=>{
        const array = [
            generateColumn(this.data, false, "Load Number", 'loadNumber',{
                ignoredSubMenu:true,
                saveOldValueInDataAttribute:true,
                // ignoreChecks:true
            }),
            
            generateColumn(this.data, true, "Load Status", 'loadStatus',{
                type: 'select',
                dataset: this.loadStatus === "Unassigned" ? ["Unassigned", "Cancelled", "Terminated", "Ready For Invoice"]: this.loadIsLocked || completedLoadStatuses.includes(this.loadStatus)  ? ["Ready For Invoice", "Not Dispatched", "Dispatched", "In Progress", "Completed", "Invoiced", "Paid", "Cancelled", "Terminated"] : ["Not Dispatched", "Dispatched", "In Progress", "Completed", "Ready For Invoice", "Cancelled", "Terminated"],
                customDisplayFormat : this.loadStatusFormatter,
                processBeforeSending : this.loadStatusFormatter,
                customDefaultInputValue:this.loadStatusFormatter(this.loadStatus),

            }),
            generateColumn(this.data, true, "Load Type", 'loadType',{
                type: 'select',
                dataset: ["Full Truck Load", "Partial", "High Value"],
                customDisplayFormat : LoadTypeFormatter,
                processBeforeSending : LoadTypeFormatter,
                customDefaultInputValue:LoadTypeFormatter(this.loadType),
            }),
            generateColumn(this.data, false, 'Booked By', [["bookedBy", "firstName"], ' ', ["bookedBy", "lastName"]], {
                dataValueRequired : true,
            }),
            generateColumn(this.data, false, 'Brokerage', [['broker', 'brokerageName']], {
                dataValueRequired : true,
                customDefaultInputValue : this.data.broker !== undefined ? `${this.data.broker['brokerageName']} (${this.data.broker['city']}, ${this.data.broker['state']})` : null,
                // ignoreChecks:true
            }),
            generateColumn(this.data, false, 'Broker Name', [['pointOfContact', 'fullName']], {
                dataIsInJSon:true,
                dataValueRequired:false,
                autoComplete : 'off',
                subMenu: true,
                parentFieldName : 'broker',
                subMenuColumnName : 'fullName'
            }),
            generateColumn(this.data, false, 'Broker Email', [['pointOfContact', 'email']], {
                dataIsInJSon:true,
                dataValueRequired:false,
                
                subMenu: true,
                parentFieldName : 'broker',
                subMenuColumnName : 'email'
            }),
            generateColumn(this.data, false, 'Broker Phone Number', [['pointOfContact', 'phoneNumber']], {
                dataIsInJSon:true,
                dataValueRequired:false,
                subMenu: true,
                parentFieldName : 'broker',
                subMenuColumnName : 'phoneNumber'
            }),
            generateColumn(this.data, false, 'Broker Telegram', [['pointOfContact', 'telegram']], {
                dataIsInJSon:true,
                dataValueRequired:false,
                autoComplete : 'off',
                subMenu: true,
                parentFieldName : 'broker',
                subMenuColumnName : 'telegram'
            }),
        ]
        if(skipFirst)array.shift();
        return array;
    }
    constructor(NestedValueExtractor, loadStatusFormatter, loadStatusColorGenerator){
        this.getLink = API_ROOT+'loads/';
        this.columnProportions = "22rem 1fr 0.6fr";
        this.NestedValueExtractor = NestedValueExtractor;
        this.loadStatusFormatter = loadStatusFormatter;
        this.loadStatusColorGenerator = loadStatusColorGenerator;
    }
    setData(data){
        
        this.data = data;    
        this.id = data['id'];
        this.loadNumber = data['loadNumber'];
        this.loadStatus = data['loadStatus'];
        this.loadIsLocked = data['loadIsLocked'] ? true : false;
        this.canSeeRates = canSeeLoadRates();
        this.currentUserCanEdit = !this.loadIsLocked
            ? can('RATES') || can('INVOICES', 'MANAGE')
            : can('EDITING_LOCKED_LOADS') || can('INVOICES', 'MANAGE');
        this.hideDriverPayoutAmount = !can('DRIVER_PAYOUTS', 'VIEW');
        this.omitDriverPayoutEditor = !can('DRIVER_PAYOUTS', 'MANAGE');
        this.loadType = data['loadType'];
        this.currentTruck = data['currentTruck'] ?data['currentTruck']['truckNumber']:"-";
        this.currentTrailer = data['currentTrailer']?data['currentTrailer']['trailerNumber']:"-";
        this.bookedBy = this.NestedValueExtractor(data, [["bookedBy", "firstName"], ' ', ["bookedBy", "lastName"]]);
        this.rateConf = data['rateCon'];
        this.brokerage = data["broker"]["brokerageName"];
        this.notes = data['notes'];
        this.pointOfContact = data['pointOfContact']?JSON.parse(data['pointOfContact']):null;
        
        this.driverPayoutTrucks = resolveDriverPayoutTrucks(this.data);
        this.driverPayoutIsEditable = shouldShowDriverPayout(this.data);
        this.driverPayoutDisplay = this.driverPayoutIsEditable
            ? formatDriverPayoutDisplay(this.data.driverPayout, {
                hideAmount: this.hideDriverPayoutAmount,
                canSeeRates: this.canSeeRates,
                loadHasStarted: Boolean(this.data.loadHasStarted),
                trucks: this.driverPayoutTrucks,
            })
            : null;
        this.driverPayoutIsSet = hasAnyExplicitDriverPayout(this.data.driverPayout);
        this.popup = data['popup'] ? true : false;
        this.usesCombinedRateMatrix = usesCombinedRateMatrix(data);
        this.header = {
            title : "Load " + (this.InfoSectionColumns()[0].val.length < (this.popup ? 3 : 5) ? this.InfoSectionColumns()[0].val : ""),
            titleVal: this.InfoSectionColumns()[0].val.length < (this.popup ? 3 : 5) ? "" : this.InfoSectionColumns()[0].val,
            status : {
                value: this.loadStatusFormatter(this.loadStatus),
                textColor: "white",
                bgColor:this.loadStatusColorGenerator(this.loadStatus),
            },
        };
        this.infoSections = [
            {
                title: "Equipment",
                editAccessLevel: this.currentUserCanEdit,
                editButton: {
                    text: this.currentTruck === '-' ? "Assign" : 'Edit',
                    action: (setDataMethod)=>{
                        LOAD_SECTION_UPDATE(setDataMethod, this.data.id, this.EquipmentSection)
                    }
                },
                columns : this.EquipmentSection()
            },
            {
                title: 'General Info',
                editAccessLevel: this.currentUserCanEdit,
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        LOAD_SECTION_UPDATE(setDataMethod, this.data.id, this.InfoSectionColumns, null, createCheckBeforeSending(this.currentTruck, this.data.id, this.data.stops))
                    }
                },
                columns : this.InfoSectionColumns(true)
            },
        ]
        this.overviewSection = [
            this.loadStatus === "Completed" ?{
                content: (setDataMethod)=>{                    
                    return <MarkAsReadyToInvoiceButton loadId={this.id} setDataMethod={setDataMethod} />
                },
                noWrap: true,
            }:null,
            {
                title : `Stops`,
                editAccessLevel: this.currentUserCanEdit,
                copyButton: () => {
                    navigator.clipboard.writeText(
                        renderLoadDispatchInfo(retrieveLoadDispatchInfoFormat(), buildDispatchDataFromLoad(this.data))
                    )
                    addNotification({message:`Copied to clipboard`, type:'notify', duration: '1000'})
                },
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        const columns = ()=>{
                            return [
                                {
                                    notInAddForm:true,
                                    label: 'Stops',
                                    name: "stops",
                                    type: 'loadPickupDeliveryStops',
                                    editMode:true,
                                    loadsCurrentStatus: this.data.loadStatus,
                                    defaultValue:()=>{
                                        return this.data.stops;
                                    }
                                }
                            ]
                        }
                        LOAD_SECTION_UPDATE(setDataMethod, this.data.id, columns, null, this.data.loadType !== "Partial" ? createCheckBeforeSending(this.currentTruck, this.data.id) : null);
                    }
                },
                content: ()=>{
                    return <StopsWithStatuses data={data["stops"]} updateData={(newStopList)=>{
                        generateUpdatedVersionOfTheObject(this.data.id, 'loads', {'stops':newStopList}).then(async payload => {
                            udpateLoad(payload, ()=>{/* Success */}, ()=>{document.location.reload()});
                        })
                    }} smallerFont={this.popup} />
                }
            },
            {
                title : `Payment`,
                editAccessLevel: this.currentUserCanEdit,
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        const allExecutors = [];
                        if(this.data.loadExecutors && this.data.loadExecutors.length>0){
                            for(let executor of this.data.loadExecutors){
                                allExecutors.push(executor)
                            }
                        }
                        const payoutTrucks = resolveDriverPayoutTrucks(this.data);
                        const showDriverPayoutField = payoutTrucks.length > 0
                            && !this.hideDriverPayoutAmount
                            && !this.omitDriverPayoutEditor;

                        const columns = ()=>{
                            const columns = [
                                generateColumn(this.data, false, "Payout", 'payout', {customDefaultInputValue: priceOnFinish(`${this.data.payout}`), ignoredSubMenu:true}),
                                showDriverPayoutField ? {
                                    notInAddForm: true,
                                    name: "driverPayout",
                                    type: "driverPayoutEditor",
                                    editMode: true,
                                    defaultValue: {
                                        driverPayout: this.data.driverPayout,
                                        data: this.data,
                                        trucks: payoutTrucks,
                                    },
                                    processChanges: (_column, data) => {
                                        const result = processDriverPayoutChanges();
                                        if (result === null) {
                                            addNotification({ message: 'Could not save driver payout.', type: 'alert' });
                                            return null;
                                        }
                                        return { ...(data || {}), ...result };
                                    },
                                } : null,
                                generateColumn(this.data, true, 'Mileage', "mileage", {autoComplete : 'off', filters:[(val)=>{
                                    const newVal = parseInt(val.replace(/[^0-9]/g,''));
                                    return isNaN(newVal)?0:newVal;
                                }], processBeforeSending:(val)=>{
                                    return parseInt(val);
                                }}),
                                generateColumn(this.data, true, 'Deadhead', "deadhead", {autoComplete : 'off', filters:[(val)=>{
                                    const newVal = parseInt(val.replace(/[^0-9]/g,''));
                                    return isNaN(newVal)?0:newVal;
                                }]}),
                                generateColumn(this.data, true, 'Fees and Charges', 'feesAndCharges', {dataIsInJSon : true, type: 'chargeOrFeeBlock'}),
                            ]
                            if(allExecutors.length > 0){
                                columns.push(generateColumn(this.data, true, 'Driver Bonuses and Charges', 'driverChargesAndBonuses', {dataIsInJSon : true, type: 'chargeOrFeeBlock', customProps: {allPreviousTrucks : allExecutors}}))
                            }
                            return columns.filter(Boolean);
                        }
                        LOAD_SECTION_UPDATE(setDataMethod, this.data.id, columns)
                    }
                },
                content: ()=>{
                    return <LoadPayoutSection
                        data={this.data}
                        smallerFont={this.popup}
                        driverPayoutIsEditable={this.driverPayoutIsEditable}
                        driverPayoutDisplay={this.driverPayoutDisplay}
                        canSeeRates={this.canSeeRates}
                        hideDriverPayoutAmount={this.hideDriverPayoutAmount}
                    />
                }
            },
            this.canSeeRates && this.usesCombinedRateMatrix ? {
                title: 'Rate Distribution',
                editAccessLevel: this.currentUserCanEdit,
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        const columns = ()=>{
                            return [
                                {
                                    notInAddForm:true,
                                    name: "rateAllocationMatrix",
                                    type: 'rateAllocationMatrix',
                                    editMode:true,
                                    defaultValue: matrixEditorDefaultValue(this.data),
                                    amountForInvoice: this.data.amountForInvoice,
                                    processChanges: () => {
                                        const result = processRateAllocationMatrixChanges();
                                        if (result === null) {
                                            const container = document.getElementById('rateAllocationMatrixEditor');
                                            const message = container?.getAttribute('data-validation-error')
                                                || 'Rate allocation must equal the full load rate.';
                                            addNotification({ message, type: 'alert' });
                                            return null;
                                        }
                                        return result;
                                    },
                                }
                            ]
                        }
                        LOAD_SECTION_UPDATE(setDataMethod, this.data.id, columns)
                    }
                },
                content: ()=>{
                    return (
                        <RateAllocationMatrix
                            viewMode={true}
                            rateAllocationMatrix={this.data.rateAllocationMatrix}
                            loadExecutors={this.data.loadExecutors}
                            rateDistributionByWeeks={this.data.rateDistributionByWeeks}
                            amountForInvoice={this.data.amountForInvoice}
                        />
                    );
                },
                headerLine:true
            }:null,
            this.canSeeRates && !this.usesCombinedRateMatrix && this.data.rateDistributionByWeeks?{
                title: 'Rate Distribution (Weeks)',
                editAccessLevel: this.currentUserCanEdit,
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        const columns = ()=>{
                            return [
                                {
                                    notInAddForm:true,
                                    // label: 'Rate Distribution (Weeks)',
                                    name: "rateDistributionByWeeks",
                                    type: 'rateDistribution',
                                    splitBy: "weeks",
                                    editMode:true,
                                    defaultValue: this.data.rateDistributionByWeeks,
                                    amountForInvoice: this.data.amountForInvoice,
                                    processChanges: (column)=>{
                                        
                                        let data = null; 
                                        const values = [];
                                        let tagIndex = 0;
                                        let grandTotal = 0;
                                        for (let input of document.getElementsByClassName("splittionSlider")){
                                            const value = parseFloat(input.getAttribute('data-full-value'));
                                            // values.push(tagIndex > 0 ? parseInt(input.value) - values[tagIndex-1]  :parseInt(input.value));
                                            values.push(value);
                                            grandTotal += values[tagIndex];
                                            tagIndex += 1;
                                        }
                                        if(values.length>0){
                                            values.push(100-grandTotal);
                                            const parsedDefaultVal = column.defaultValue;
                                            if(parsedDefaultVal.length === values.length){
                                                for(const [index, value] of parsedDefaultVal.entries()){
                                                    value.percentage = values[index]/100;
                                                }
                                            }
                                            data = parsedDefaultVal
                                        }
                                        return {"rateDistributionByWeeks" : data};
                                    }
                                }
                            ]
                        }
                        LOAD_SECTION_UPDATE(setDataMethod, this.data.id, columns)
                    }
                },
                content: ()=>{
                    return <Splitter viewMode={true} data={this.data.rateDistributionByWeeks} amountForInvoice={this.data.amountForInvoice} splitBy="weeks" />
                },
                headerLine:true
            }:null,
            this.canSeeRates && !this.usesCombinedRateMatrix && this.data.loadExecutors && this.data.loadExecutors.length>1 && this.data.loadHasStarted?{
                title: 'Rate Distribution (Trucks)',
                editAccessLevel: this.currentUserCanEdit,
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        const columns = ()=>{
                            return [
                                {
                                    notInAddForm:true,
                                    // label: 'Rate Distribution (Weeks)',
                                    name: "loadExecutors",
                                    type: 'rateDistribution',
                                    editMode:true,
                                    defaultValue: this.data.loadExecutors,
                                    amountForInvoice: this.data.amountForInvoice,
                                    processChanges: (column)=>{
                                        let data = null; 
                                        const values = [];
                                        let tagIndex = 0;
                                        let grandTotal = 0;
                                        let alreadyHunder = false;
                                        for (let input of document.getElementsByClassName("splittionSlider")){
                                            const value = parseFloat(input.getAttribute('data-full-value'));
                                            const currentVal = tagIndex > 0 ? !alreadyHunder ? value - values[tagIndex-1] : 0  : value;
                                            if(currentVal === 100){
                                                alreadyHunder = true;
                                            }
                                            values.push(currentVal);
                                            grandTotal += values[tagIndex];
                                            tagIndex += 1;
                                        }
                                        if(values.length>0){
                                            values.push(100-grandTotal);
                                            const parsedDefaultVal = column.defaultValue;
                                            if(parsedDefaultVal.length === values.length){
                                                for(let i = 0; i < parsedDefaultVal.length; i++){
                                                    parsedDefaultVal[i].percentage = values[i]/100;
                                                }
                                            }
                                            data = parsedDefaultVal;
                                        }
                                        return {"loadExecutors" : data};
                                    }
                                }
                            ]
                        }
                        LOAD_SECTION_UPDATE(setDataMethod, this.data.id, columns)
                    }
                },
                content: ()=>{
                    return <Splitter viewMode={true} data={this.data.loadExecutors} amountForInvoice={this.data.amountForInvoice} />
                },
                headerLine:true
            }:null,
            {
                title : `Files`,
                editAccessLevel: this.loadStatus === "ReadyForInvoice" || this.loadStatus === "Invoiced" || this.loadStatus === "Paid"  ? { key: 'INVOICES', level: 'MANAGE' } : false,
                editButton : {
                    text: this.data.invoiceNumber > 0 ? 'Rebuild Invoice' : 'Generate Invoice File',
                    action: (setDataMethod, e)=>{
                        addAndRemoveLoadingIcon(e.target)
                        sendRequest('POST', API_ROOT+"loads/rebuildinvoice?loadId="+this.id, null, (arr)=>{
                            setDataMethod(prev => {
                                const invoiceRegenerated = this.data.invoiceNumber !== 0;
                                return {...prev, "files" : arr, invoiceNumber : invoiceRegenerated ? prev.invoiceNumber : 1, loadStatus : invoiceRegenerated ? prev.loadStatus : "Invoiced" }
                            })
                            addNotification({message:`Invoice Regenerated`, type:'notify', duration: '1000'});
                            addAndRemoveLoadingIcon(e.target, true)
                        }, ()=>{
                            addNotification({message:`Something went wrong`, type:'alert', duration: '1000'});
                            addAndRemoveLoadingIcon(e.target, true)
                        });
                    }
                },
                content: (setDataMethod)=>{
                    return <FilesListing files={data["files"]} loadId={data['id']} setDataMethod={setDataMethod} />
                },
                headerLine :true
            },
            {
                title : `Latest Activities`,
                content: ()=>{
                    return <LatestActivitiesSection
                        type="LOAD"
                        initData={parseArrayOfStrings(data["latestActivities"])}
                        objectId={data['id']}
                        canSeeRates={this.canSeeRates}
                        hideDriverPayoutAmount={this.hideDriverPayoutAmount}
                    />
                },
                headerLine :true
            }
        ]
        this.notesSection = {

        }
    }
}

export function checkIfTruckHasOverlayingLoads (TruckNumber, newLoadLoadId, newLoadsStartDate, newLoadsEndDate, target, column, returningResponse){
    sendRequest("GET", API_ROOT+"trucks/checkIfHasLoads?trucknumber="+TruckNumber, null,
        (loads)=>{
            let overlappingLoadExists = false;
            for (const load of loads){
                
                const currentFirstStopDate = new Date(normalizeDate(newLoadsStartDate)+"T00:00");
                const currentLastStopDate = new Date(normalizeDate(newLoadsEndDate)+"T00:00");
                const firstStopDate = new Date(load.startDate+"T00:00");
                const lastStopDate = new Date(load.endDate+"T00:00");
                
                if(newLoadLoadId && newLoadLoadId !== "" && load.id === newLoadLoadId){
                    continue;
                }
                
                
                if (!(currentLastStopDate <= firstStopDate || currentFirstStopDate >= lastStopDate)){
                    overlappingLoadExists = true;
                    addPopup({
                        content:ConfirmationDialogue, 
                        popupData: {
                            confirmationDialogue:true,
                            oneButton: true,
                            action:(postResultAction)=>{
                                postResultAction(true);
                                if(returningResponse){
                                    returningResponse(false)
                                }
                                if(target){
                                    target.setAttribute('data-value', '');
                                    if(column){
                                        target.value = column.defaultValue();
                                    }
                                }
                            },
                            cancelAction:(closePopup)=>{
                                
                                closePopup()
                            },
                            name:"Confirm",
                            formTitle:"Conflicting Loads",
                            submitTitle:"Ok",
                            message:`Truck ${TruckNumber} is assigned to the load ${load.loadNumber} with overlapping dates. Such load cannot be assigned to this truck.
                            `
                        }, 
                        postSuccessAction: ()=>{
                        }, 
                        EZCloseAllowed:false
                    });
                    break;
                }
            }
            
            if(!overlappingLoadExists && returningResponse){
                returningResponse(true);
            }
        }, (e)=>{
            if(target){
                target.setAttribute('data-value', '');
                target.value = '';
            }
        })
}
function normalizeDate(dateStr) {
    // Match MM/DD/YY or MM/DD/YYYY
    const shortFormatRegex = /^(\d{2})\/(\d{2})\/(\d{2}|\d{4})$/;
  
    const match = dateStr.match(shortFormatRegex);
    if (match) {
      let [, mm, dd, yy] = match;
  
      // Return ISO format: yyyy-MM-dd
      return `20${yy}-${mm}-${dd}`;
    }
  
    // Already ISO or unrecognized — return as-is
    return dateStr;
}
// {
            //     label: "Dispatched By",
            //     val: this.dispatchedBy,
            //     name: "dispatchedBy",
            //     notInAddForm:true,
            //     suggestionsEnabled: true,
            //     suggestionsLink: API_ROOT+'employees/dispatchByName?pattern=', // link to send request to obtain suggestions
            //     displayValueGenerator: (val)=>{return `${val['nickName']} (${val['firstName']})`},
            //     displayValueToRawValue: (value)=>{ return value.substr(0, value.indexOf('(')).trim();},
            //     defaultValue:(ref)=>{
            //         if(ref.current  !== null){
            //             ref.current.setAttribute('data-value', JSON.stringify(this.data.dispatchedBy));
            //             return this.dispatchedBy;
            //         }
            //     }
            // },